import React, { useCallback, useEffect, useState } from 'react';

import './Style.css';
import { CSSTransition } from 'react-transition-group';

import HelpIcon from '@material-ui/icons/Help';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { CheckBox, SelectInput } from '../../../Components/index';
import { OrderDetails } from '../..';

const Index = React.memo(() => {
    const [showdetails, setShowdetails] = useState(false);

    //////
    // Selected Items
    //////
    const [selectedItems, setSelectedItems] = useState([]);
    const [show, setShow] = useState(false);
    const [status, setStatus] = useState('');

    useEffect(() => {
        setShow(selectedItems.length > 0 ? true : false);
    }, [selectedItems]);

    const handlerUnSelect = useCallback((id) => {
        setSelectedItems((prev) => {
            let old = [...prev];
            const index = old.findIndex((ele) => ele === id);
            if (index !== -1) {
                old.splice(index, 1);
            }
            return old;
        });
    }, []);

    const handlerSelect = useCallback((id) => {
        setSelectedItems((prev) => {
            return [...prev, id];
        });
    }, []);

    const selectAll = (value, state) => {
        if (state) {
            setSelectedItems([]);
        } else {
            setSelectedItems([
                'ANA98MM1001SMMS',
                'ANA98MM1001SMM',
                'AANA98MMS1001MM',
                'AANA98MM1001MM',
                'ANA98MM1001MM2',
                'ANA98MM1001MM',
            ]);
        }
    };

    return (
        <>
            <OrderDetails
                state={showdetails}
                setStateFalse={() => {
                    setShowdetails((prev) => !prev);
                }}
            />
            <CSSTransition
                unmountOnExit
                mountOnEnter
                in={show}
                classNames="show-selection"
                timeout={{ exit: 200, enter: 40 }}
            >
                <div className="selection_sidebar">
                    <div>
                        <SelectInput
                            label="Change All Status"
                            outlined={true}
                            value={status}
                            changeHandler={(e) => {
                                setStatus(e.target.value);
                                console.log('Changed All Status!');
                            }}
                            options={[
                                { name: 'None', value: '' },
                                { name: 'Processing', value: 'Processing' },
                                { name: 'Ready To Dispatch', value: 'Ready To Dispatch' },
                                { name: 'Dispatched', value: 'Dispatched' },
                                { name: 'On Hold', value: 'On Hold' },
                                { name: 'Cancelled', value: 'Cancelled' },
                                { name: 'Return', value: 'Return' },
                            ]}
                        />
                    </div>
                    <button style={{ margin: '2rem auto' }} className="btn-orange">
                        <p>Download Orders</p>
                    </button>
                </div>
            </CSSTransition>
            <div
                style={{
                    overflowY: 'hidden',
                    overflowX: 'auto',
                    padding: '1rem',
                    position: 'relative',
                }}
            >
                <table className="merch_manageorder_table">
                    <thead className="merch_manageorder_table_head">
                        <tr className="merch_manageorder_table_head_row">
                            <td>
                                <CheckBox handleChange={selectAll} name="all" checked={false} labeling="" />
                            </td>
                            <td className="merch_manageorder_table_head_data">Order ID</td>
                            <td className="merch_manageorder_table_head_data">Merchant Name</td>
                            <td className="merch_manageorder_table_head_data">Change to...</td>
                            <td className="merch_manageorder_table_head_data">Products</td>
                            <td className="merch_manageorder_table_head_data">Price</td>
                            <td className="merch_manageorder_table_head_data">Payment Type</td>

                            <td className="merch_manageorder_table_head_data"></td>
                        </tr>
                    </thead>
                    <tbody className="merch_manageorder_table_body">
                        <Component
                            id="ANA98MM1001SMMS"
                            check={selectedItems.findIndex((ele) => ele === 'ANA98MM1001SMMS') !== -1}
                            paymentMethod="Online"
                            merchant="Jonas Scheman"
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            status="processing"
                            products={[
                                { name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 },
                                { name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 },
                                { name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 },
                                { name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 },
                            ]}
                            price={183.75}
                            qty={1}
                            handlerUnSelect={handlerUnSelect}
                            handlerSelect={handlerSelect}
                        />
                        <Component
                            id="ANA98MM1001SMM"
                            paymentMethod="Online"
                            check={selectedItems.findIndex((ele) => ele === 'ANA98MM1001SMM') !== -1}
                            merchant="Jonas Scheman"
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            status="ready to Dispatched"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            price={183.75}
                            qty={1}
                            handlerUnSelect={handlerUnSelect}
                            handlerSelect={handlerSelect}
                        />
                        <Component
                            id="AANA98MMS1001MM"
                            paymentMethod="Online"
                            check={selectedItems.findIndex((ele) => ele === 'AANA98MMS1001MM') !== -1}
                            merchant="Jonas Scheman"
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            status="Dispatched"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            price={183.75}
                            qty={1}
                            handlerUnSelect={handlerUnSelect}
                            handlerSelect={handlerSelect}
                        />
                        <Component
                            id="AANA98MM1001MM"
                            paymentMethod="Online"
                            check={selectedItems.findIndex((ele) => ele === 'AANA98MM1001MM') !== -1}
                            merchant="Jonas Scheman"
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            status="On hold"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            price={183.75}
                            qty={1}
                            handlerUnSelect={handlerUnSelect}
                            handlerSelect={handlerSelect}
                        />
                        <Component
                            id="ANA98MM1001MM2"
                            paymentMethod="Online"
                            check={selectedItems.findIndex((ele) => ele === 'ANA98MM1001MM2') !== -1}
                            merchant="Jonas Scheman"
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            status="Cancelled"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            price={183.75}
                            qty={1}
                            handlerUnSelect={handlerUnSelect}
                            handlerSelect={handlerSelect}
                        />
                        <Component
                            id="ANA98MM1001MM"
                            paymentMethod="Online"
                            check={selectedItems.findIndex((ele) => ele === 'ANA98MM1001MM') !== -1}
                            merchant="Jonas Scheman"
                            clickhandler={() => {
                                setShowdetails((prev) => !prev);
                            }}
                            status="Return"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            price={183.75}
                            qty={1}
                            handlerUnSelect={handlerUnSelect}
                            handlerSelect={handlerSelect}
                        />
                    </tbody>
                </table>
            </div>
        </>
    );
});

const Component = ({
    id,
    clickhandler,
    status,
    check,
    products,
    merchant,
    paymentMethod,
    handlerUnSelect,
    handlerSelect,
}) => {
    const [show, setshow] = useState(false);
    const handlerChange = (id, state) => {
        if (check) {
            handlerUnSelect(id);
        } else {
            handlerSelect(id);
        }
    };

    return (
        <tr className="merch_manageorder_table_body_row">
            <td>
                <div className="select_box_comp_comp">
                    <CheckBox isAlt name={id} checked={check} handleChange={handlerChange} value={id} labeling="" />
                </div>
            </td>
            <td onClick={clickhandler} className="merch_manageorder_table_body_data">
                {id}
            </td>
            <td onClick={clickhandler} className="merch_manageorder_table_body_data">
                {merchant}
            </td>
            <td onClick={clickhandler} className="merch_manageorder_table_body_data">
                <div className="merch_manageorder_table_body_change">
                    <p className={`circle ${status.replace(/\s/g, '')}`}></p>
                    <span>{status}</span>
                </div>
            </td>
            <td onClick={clickhandler} className="merch_manageorder_table_body_data">
                <div style={{ position: 'relative', display: 'flex' }}>
                    <p>{products[0].name.slice(0, 12)}...</p>
                    <HelpIcon
                        onClick={(e) => {
                            e.preventDefault();
                            setshow((prev) => !prev);
                        }}
                        className="icon"
                    />

                    <p className={`product_details ${show ? 'show' : ''}`}>
                        {products.map((ele) => (
                            <p key={ele.name}>
                                {ele.name} X {ele.quantity}
                            </p>
                        ))}
                    </p>
                </div>
            </td>

            <td onClick={clickhandler} className="merch_manageorder_table_body_data">
                ₹ {products.reduce((prev, curr) => prev + curr.quantity * curr.price, 0)}
            </td>
            <td onClick={clickhandler} className="merch_manageorder_table_body_data">
                {paymentMethod}
            </td>

            <td className="merch_manageorder_table_body_data">
                <div className="merch_table_icons">
                    <DeleteForeverIcon className="merch_table_icon" />
                    <SaveAltIcon className="merch_table_icon" />
                </div>
            </td>
        </tr>
    );
};

export default Index;
